export default "__VITE_ASSET__fmZ3QEh___"